import React from 'react';
import './PrivacyPolicy.css';
const Terminos = () => {
   return (
      <div className="privacy-policy-container">
        <h1>Políticas de Privacidad</h1>
        <p className="last-updated">Última actualización: 10-03-2025</p>
  
        <p>
          Bienvenido(a) a <strong>EETHSAAPP</strong> (en adelante,
          "la Aplicación"), operada por{' '}
          <strong>ASLATEC</strong> (en adelante,
          "nosotros", "nuestro" o "la Empresa"). Nos comprometemos a proteger tu
          privacidad y a garantizar que tus datos personales sean tratados de
          manera segura y transparente. Esta Política de Privacidad describe cómo
          recopilamos, usamos, compartimos y protegemos tu información cuando
          utilizas nuestra Aplicación.
        </p>
  
        <p>
          Al utilizar <strong>EETHSAAPP</strong>, aceptas las
          prácticas descritas en esta Política de Privacidad. Si no estás de
          acuerdo con estas prácticas, te pedimos que no utilices la Aplicación.
        </p>
  
        <section>
          <h2>1. Información que Recopilamos</h2>
          <p>
            Podemos recopilar los siguientes tipos de información cuando utilizas
            nuestra Aplicación:
          </p>
  
          <h3>a) Información que nos proporcionas directamente</h3>
          <ul>
            <li>
              <strong>Datos de registro:</strong> Como tu nombre, dirección de
              correo electrónico, número de teléfono u otra información que
              proporciones al registrarte o al completar formularios en la
              Aplicación.
            </li>
            <li>
              <strong>Información de perfil:</strong> Si creas un perfil, podemos
              recopilar datos como tu foto de perfil, preferencias o cualquier
              información que decidas compartir.
            </li>
            <li>
              <strong>Comunicaciones:</strong> Información que nos envías al
              contactarnos a través de soporte, formularios o redes sociales.
            </li>
          </ul>
  
          <h3>b) Información recopilada automáticamente</h3>
          <ul>
            <li>
              <strong>Datos de uso:</strong> Información sobre cómo interactúas
              con la Aplicación, como las funciones que utilizas, el tiempo que
              pasas en la Aplicación, las páginas visitadas y las acciones
              realizadas.
            </li>
            <li>
              <strong>Datos del dispositivo:</strong> Información técnica como el
              modelo de tu dispositivo, sistema operativo, dirección IP,
              identificadores únicos del dispositivo (como IDFA o Android ID), tipo
              de navegador y configuración de idioma.
            </li>
            <li>
              <strong>Ubicación:</strong> Si habilitas los servicios de ubicación,
              podemos recopilar datos aproximados o precisos sobre tu ubicación.
            </li>
            <li>
              <strong>Cookies y tecnologías similares:</strong> Utilizamos cookies
              y tecnologías de seguimiento para mejorar tu experiencia y analizar
              el uso de la Aplicación.
            </li>
          </ul>
  
          <h3>c) Información de terceros</h3>
          <p>
            Podemos recibir información tuya de terceros, como redes sociales, si
            decides vincular tu cuenta de <strong>EETHSAAPP</strong>{' '}
            con dichas plataformas (por ejemplo, al iniciar sesión con Google o
            Facebook).
          </p>
        </section>
  
        <section>
          <h2>2. Cómo Utilizamos tu Información</h2>
          <p>
            Utilizamos la información recopilada para los siguientes fines:
          </p>
          <ul>
            <li>
              <strong>Proveer y mejorar la Aplicación:</strong> Para ofrecerte los
              servicios, personalizar tu experiencia y desarrollar nuevas
              funciones.
            </li>
            <li>
              <strong>Comunicarnos contigo:</strong> Enviarte notificaciones,
              actualizaciones, respuestas a tus consultas o información sobre la
              Aplicación.
            </li>
            <li>
              <strong>Analizar y optimizar:</strong> Comprender cómo los usuarios
              interactúan con la Aplicación para mejorar su rendimiento y
              funcionalidad.
            </li>
            <li>
              <strong>Publicidad y marketing:</strong> Mostrarte anuncios
              personalizados o enviarte promociones (si das tu consentimiento).
            </li>
            <li>
              <strong>Cumplir con obligaciones legales:</strong> Para cumplir con
              leyes aplicables, regulaciones o solicitudes legales.
            </li>
          </ul>
        </section>
  
        <section>
          <h2>3. Cómo Compartimos tu Información</h2>
          <p>
            No vendemos tu información personal a terceros. Sin embargo, podemos
            compartir tu información en los siguientes casos:
          </p>
          <ul>
            <li>
              <strong>Proveedores de servicios:</strong> Compartimos datos con
              terceros que nos ayudan a operar la Aplicación, como servicios de
              alojamiento, análisis de datos o envío de correos electrónicos.
            </li>
            <li>
              <strong>Socios publicitarios:</strong> Podemos compartir datos
              anonimizados o agregados con socios publicitarios para mostrar
              anuncios relevantes.
            </li>
            <li>
              <strong>Cumplimiento legal:</strong> Si es requerido por la ley,
              podemos divulgar tu información a autoridades gubernamentales o para
              proteger nuestros derechos legales.
            </li>
            <li>
              <strong>Transferencias comerciales:</strong> En caso de fusión,
              adquisición o venta de activos, tu información podría ser transferida
              como parte del negocio.
            </li>
          </ul>
        </section>
  
        <section>
          <h2>4. Base Legal para el Tratamiento de Datos</h2>
          <p>
            Procesamos tus datos personales bajo las siguientes bases legales
            (según aplique):
          </p>
          <ul>
            <li>
              <strong>Consentimiento:</strong> Cuando das tu consentimiento
              explícito, como al aceptar estas Políticas o al habilitar funciones
              como la geolocalización.
            </li>
            <li>
              <strong>Ejecución de un contrato:</strong> Cuando el tratamiento es
              necesario para proporcionarte los servicios de la Aplicación.
            </li>
            <li>
              <strong>Obligación legal:</strong> Cuando estamos obligados a cumplir
              con requisitos legales o regulatorios.
            </li>
            <li>
              <strong>Intereses legítimos:</strong> Cuando el tratamiento es
              necesario para nuestros intereses legítimos, como mejorar la
              Aplicación o prevenir fraudes, siempre que no prevalezcan tus
              derechos.
            </li>
          </ul>
        </section>
  
        <section>
          <h2>5. Tus Derechos</h2>
          <p>
            Dependiendo de tu ubicación y las leyes aplicables, puedes tener los
            siguientes derechos respecto a tus datos personales:
          </p>
          <ul>
            <li>
              <strong>Acceso:</strong> Solicitar una copia de los datos que hemos
              recopilado sobre ti.
            </li>
            <li>
              <strong>Rectificación:</strong> Corregir datos inexactos o
              incompletos.
            </li>
            <li>
              <strong>Eliminación:</strong> Pedir que eliminemos tus datos
              personales (sujeto a excepciones legales).
            </li>
            <li>
              <strong>Oposición:</strong> Oponerte al tratamiento de tus datos
              para ciertos fines, como marketing directo.
            </li>
            <li>
              <strong>Portabilidad:</strong> Solicitar que te entreguemos tus
              datos en un formato estructurado y legible.
            </li>
            <li>
              <strong>Retirar consentimiento:</strong> Si el tratamiento se basa
              en tu consentimiento, puedes retirarlo en cualquier momento.
            </li>
          </ul>
          <p>
            Para ejercer tus derechos, contáctanos en{' '}
            <a href="mailto:soporte@aslatec.com.py">
              soporte@aslatec.com.py
            </a>
            . Responderemos a tu solicitud dentro de los plazos establecidos por la
            ley.
          </p>
        </section>
  
        <section>
          <h2>6. Seguridad de tu Información</h2>
          <p>
            Implementamos medidas técnicas y organizativas para proteger tus datos
            personales contra accesos no autorizados, pérdida, alteración o
            divulgación. Sin embargo, ningún sistema es completamente seguro, por
            lo que no podemos garantizar la seguridad absoluta de tu información.
          </p>
        </section>
  
        <section>
          <h2>7. Retención de Datos</h2>
          <p>
            Conservaremos tus datos personales solo durante el tiempo necesario
            para cumplir con los fines descritos en esta Política o según lo exijan
            las leyes aplicables. Por ejemplo, eliminaremos datos de cuentas
            inactivas después de [período de tiempo, e.g., 12 meses], a menos que
            exista una obligación legal de retenerlos.
          </p>
        </section>
  
        <section>
          <h2>8. Transferencias Internacionales</h2>
          <p>
            Si operamos en múltiples países, tus datos pueden ser transferidos a
            servidores ubicados fuera de tu país de residencia. Nos aseguraremos de
            que dichas transferencias cumplan con las leyes aplicables y de que se
            implementen salvaguardas adecuadas.
          </p>
        </section>
  
        <section>
          <h2>9. Privacidad de Menores</h2>
          <p>
            <strong>EETHSAAPP</strong> no está dirigida a menores
            de [edad mínima, e.g., 13 o 16 años, según la legislación aplicable].
            No recopilamos intencionalmente información de menores de edad. Si
            descubrimos que hemos recopilado datos de un menor sin el
            consentimiento de un tutor legal, los eliminaremos de inmediato.
          </p>
        </section>
  
        <section>
          <h2>10. Cambios a esta Política de Privacidad</h2>
          <p>
            Podemos actualizar esta Política de Privacidad periódicamente para
            reflejar cambios en nuestras prácticas o en las leyes aplicables. Te
            notificaremos sobre cambios significativos mediante un aviso en la
            Aplicación o por correo electrónico. La versión más reciente siempre
            estará disponible en{' '}
            <a href="https://eethsaapp.xyz/Terminos">
              https://eethsaapp.xyz/Terminos
            </a>
            .
          </p>
        </section>
  
        <section>
          <h2>11. Contacto</h2>
          <p>
            Si tienes preguntas, inquietudes o deseas ejercer tus derechos, puedes
            contactarnos en:
          </p>
          <ul>
            <li>
              <strong>Correo electrónico:</strong>{' '}
              <a href="mailto:soporte@aslatec.com.py">
                soporte@aslatec.com.py
              </a>
            </li>
            <li>
              <strong>Dirección:</strong> Dr. José Gaspar Rodríguez de Francia, Luque 110932
            </li>
            <li>
              <strong>Teléfono:</strong> 0986873181
            </li>
          </ul>
        </section>
      </div>
    );
  };

export default Terminos;
